module.exports = __webpack_public_path__ + "img/cyclolinopeptide Q.1e519e16.png";